import { createSlice } from '@reduxjs/toolkit';
import {
    sueloNodo,
} from '../actions/sueloNodo';


export const SueloReducerNodo = createSlice({
    name: 'sueloNodo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(sueloNodo.pending, (state) => { state.loading = true })
            .addCase(sueloNodo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(sueloNodo.rejected, (state) => { state.loading = false })
    }
})

export default SueloReducerNodo.reducer;